"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A11yButton = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var A11yButton = _styledComponents.default.button(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n"], ["\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n"])));

exports.A11yButton = A11yButton;
var templateObject_1;